import React, { useEffect, useState } from "react";
import Button from "../Button";
import Modal from "../Modal";
import Input from "../Input";
import api from "../../services/api";
import { toast } from "react-toastify";
import { renderError } from "../../helpers/errors";
import InputCheckboxUnique from "../InputCheckboxUnique";
import axios from "axios";
import states from "../../seeds/states";
import InputSelect from "../InputSelect";

export const ModalCreateAddress = ({ show, close, onAddressStored, companyId, customerId, type, address }) => {
    const [loading, setLoading] = useState(false);

    const [zipCode, setZipCode] = useState("");
    const [street, setStreet] = useState("");
    const [number, setNumber] = useState("");
    const [complement, setComplement] = useState("");
    const [district, setDistrict] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [isDefault, setIsDefault] = useState(true);

    const entityId = companyId || customerId;
    const entityName = companyId ? 'company' : 'customer';
    const isEditMode = !!address;

    useEffect(() => {
        if (show) {
            if (isEditMode) {
                setZipCode(address.zip_code || "");
                setStreet(address.street || "");
                setNumber(address.number || "");
                setComplement(address.complement || "");
                setDistrict(address.district || "");
                setCity(address.city || "");
                setState(address.state || "");
                setIsDefault(address.is_default || false);
            } else {
                clean();
            }
        }
    }, [show, address, isEditMode]);

    // Buscar endereço na ViaCEP quando o CEP mudar
    useEffect(() => {
        getAddress();
    }, [zipCode]);

    const getAddress = () => {
        let convertedZipCode = zipCode.replace('-', '');
        if (convertedZipCode.length === 8) {
            axios.get(`https://viacep.com.br/ws/${convertedZipCode}/json/`).then(res => {
                let address = res.data;
                if (!address.erro) {
                    setStreet(address.logradouro || "");
                    setDistrict(address.bairro || "");
                    setCity(address.localidade || "");
                    setState(address.uf || "");
                }
            }).catch(() => {
                // Ignorar erros silenciosamente
            });
        }
    };

    const saveAddress = async () => {
        setLoading(true);

        try {
            const payload = {
                type: type,
                zip_code: zipCode,
                street,
                number,
                complement,
                district,
                city,
                state,
                is_default: isDefault
            };

            let response;
            if (isEditMode) {
                response = await api.put(`/${entityName}/${entityId}/address/${address.id}`, payload);
                toast.success("Endereço atualizado com sucesso");
            } else {
                // Modo criação: POST
                response = await api.post(`/${entityName}/${entityId}/address`, payload);
                toast.success("Endereço cadastrado com sucesso");
            }

            const savedAddress = response.data.resource;
            if (typeof onAddressStored === "function") {
                onAddressStored(savedAddress);
            }

            setLoading(false);
            clean();
            close();
        } catch (error) {
            renderError(error);
            setLoading(false);
        }
    };

    const clean = () => {
        setZipCode("");
        setStreet("");
        setNumber("");
        setComplement("");
        setDistrict("");
        setCity("");
        setState("");
        setIsDefault(true);
    };

    return (
        <Modal
            title={`${isEditMode ? "Editar" : "Cadastrar"} endereço de ${type === 'shipping' ? 'entrega' : 'cobrança'}`}
            show={show}
            close={close}
            footer={
                <Button
                    type={`primary`}
                    size={`small`}
                    text={isEditMode ? "Salvar" : "Cadastrar"}
                    svg={`save-white`}
                    action={saveAddress}
                    loading={loading}
                />
            }
        >
            <div className="section">
                <div className="row">
                    <div className="col-6">
                        <Input
                            type={`text`}
                            label={`CEP`}
                            change={setZipCode}
                            value={zipCode}
                            mask={`convertToCep`}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <Input
                            type={`text`}
                            label={`Rua`}
                            change={setStreet}
                            value={street}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <Input
                            type={`text`}
                            label={`Número`}
                            change={setNumber}
                            value={number}
                        />
                    </div>
                    <div className="col-6">
                        <Input
                            type={`text`}
                            label={`Complemento`}
                            change={setComplement}
                            value={complement}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-4">
                        <InputSelect label={`Estado`} options={states} value={state} change={setState} />
                    </div>
                    <div className="col-8">
                        <Input
                            type={`text`}
                            label={`Cidade`}
                            change={setCity}
                            value={city}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <Input
                            type={`text`}
                            label={`Bairro`}
                            change={setDistrict}
                            value={district}
                        />
                    </div>
                </div>
                {isEditMode &&
                <InputCheckboxUnique
                    label={`Endereço de ${type === 'shipping' ? 'entrega' : 'cobrança'} padrão`}
                    change={setIsDefault}
                    checked={isDefault}
                    />
                }
            </div>
        </Modal>
    );
};

export default ModalCreateAddress;